import React from 'react';

export interface MultilineTipsAndTutorialsCardProps {
  href: string;
  src: string;
  thumbnailAlt: string;
  category: string;
  text: string;
}

export const MultilineTipsAndTutorialsCard = (
  props: MultilineTipsAndTutorialsCardProps
) => {
  return (
    <div className="w-auto p-3 text-black">
      <a href={props.href} className="text-black no-underline">
        <img
          className="h-auto max-w-lg w-full rounded-md"
          src={props.src}
          alt={props.thumbnailAlt}
        />
      </a>
      <a href={props.href} className="text-black no-underline">
        <div className="text-sm tracking-widest text-black capitalize no-underline leading-10">
          {props.category}
        </div>
      </a>
      <a href={props.href} className="text-black">
        <div className="text-xl text-black font-bold">{props.text}</div>
      </a>
    </div>
  );
};

export default MultilineTipsAndTutorialsCard;
